// extracted by mini-css-extract-plugin
export default {"gridheight":"Notes_gridheight__227sH","notes-tile":"Notes_notes-tile__febRh"};